import { getImageIconSize } from '../../../theme/icons/utils';
export var _imageIconTheme = {
  baseStyle: {
    display: 'inline-flex',
    _readOnly: {
      opacity: '0.65'
    },
    _disabled: {
      opacity: '0.35'
    }
  },
  sizes: {
    'extra-small': getImageIconSize,
    small: getImageIconSize,
    medium: getImageIconSize,
    large: getImageIconSize,
    'extra-large': getImageIconSize
  }
};
//# sourceMappingURL=_ImageIcon.theme.js.map